import { render, staticRenderFns } from "./configVisualizacaoRelatorio.vue?vue&type=template&id=be236706&scoped=true"
import script from "./configVisualizacaoRelatorio.vue?vue&type=script&lang=js"
export * from "./configVisualizacaoRelatorio.vue?vue&type=script&lang=js"
import style0 from "./configVisualizacaoRelatorio.vue?vue&type=style&index=0&id=be236706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be236706",
  null
  
)

export default component.exports